const CANCEL_EVENT_TYPE = 'TASK_CANCELLED'
const FAIL_EVENT_TYPE = 'TASK_FAILED'

const CANCEL_FALLBACK: Record<string, string> = {
  admin: 'Cancelled by an admin.',
  automation: 'Cancelled by automation.',
}

export function eventDataWithReasonFirst(
  eventType: string,
  eventData: Record<string, unknown> | null | undefined
): Record<string, unknown> | null | undefined {
  if (!eventData) {
    return eventData
  }
  if (eventType !== CANCEL_EVENT_TYPE && eventType !== FAIL_EVENT_TYPE) {
    return eventData
  }

  const reason = friendlyEventReason(eventType, eventData)
  if (!reason) {
    return eventData
  }

  const { reason: _storedReason, ...rest } = eventData
  return { reason, ...rest }
}

function friendlyEventReason(
  eventType: string,
  eventData: Record<string, unknown>
): string | null {
  const sentence =
    firstNonEmptyString(eventData.reason) ??
    firstNonEmptyString(
      eventData.error && typeof eventData.error === 'object'
        ? (eventData.error as { message?: unknown }).message
        : undefined
    )

  if (sentence) {
    return sentence
  }

  if (eventType === CANCEL_EVENT_TYPE) {
    const initiator = firstNonEmptyString(eventData.initiator)
    return initiator ? (CANCEL_FALLBACK[initiator] ?? null) : null
  }

  return null
}

function firstNonEmptyString(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null
  }
  const trimmed = value.trim()
  return trimmed === '' ? null : trimmed
}
